module.exports = __webpack_public_path__ + "img/file_icon.6170d5c9.svg";